import { ITableFieldDictionary } from 'src/app/interfaces/field-settings.interface';
import { DataTypes } from 'src/shared/enums/data-type.enum';

const CalibrationParkingDictionary: ITableFieldDictionary = {
    Residential: { label: 'Space per Residential Unit', type: DataTypes.FLOAT },
    ResidentialVisitors: { label: 'Visitor Spaces per Residential Unit', type: DataTypes.FLOAT },
    ResidentialTODBenefitReduction: { label: 'Residential Benefit Reduction', type: DataTypes.FLOAT },
    LodgingRooms: { label: 'Spaces per Lodging Room', type: DataTypes.FLOAT },
    LodgingVisitors: { label: 'Visitor Spaces per Lodging Room', type: DataTypes.FLOAT },
    LodgingTODBenefitReduction: { label: 'Lodging Benefit Reduction', type: DataTypes.FLOAT },
    Office: { label: 'Spaces per Office Area', type: DataTypes.FLOAT },
    OfficeTODBenefitReduction: { label: 'Office Benefit Reduction', type: DataTypes.FLOAT },
    Commercial: { label: 'Spaces per Commercial Area', type: DataTypes.FLOAT },
    CommercialTODBenefitReduction: { label: 'Comm. Benefit Reduction', type: DataTypes.FLOAT },
    CivicAssembly: { label: 'Spaces per Civic Area', type: DataTypes.FLOAT },
    CivicTODBenefitReduction: { label: 'Civic Benefit Reduction', type: DataTypes.FLOAT },
    TODMaxDistanceToStation: { label: 'Maximum Distance to Station', type: DataTypes.FLOAT },
    TODMinDistanceToLowDensity: { label: 'Minimum Distance from Low Density Zone', type: DataTypes.FLOAT }
};

export default CalibrationParkingDictionary;
